/**
 * Traffic Impact Enum
 *
 * How an obstruction affects traffic flow. Mirrors backend
 * `GeoMarkup.Domain.Enums.TrafficImpact` — stored as PascalCase strings.
 */
export enum TrafficImpact {
  /** No traffic restriction. */
  NoRestriction = 'NoRestriction',
  /** Reduced number of lanes available. */
  ReducedLanes = 'ReducedLanes',
  /** Single-lane alternating traffic flow. */
  AlternatingTraffic = 'AlternatingTraffic',
  /** Detour around the obstruction. */
  Detour = 'Detour',
  /** Full road closure. */
  FullClosure = 'FullClosure',
}
